import BaseService from "./BaseService";
import AppConfiguration from "dataProvider/config";

export default class CameraService extends BaseService {
  constructor() {
    super(AppConfiguration.apiBaseMap, "camera/v2");
  }

  /**
   * Lấy danh sách cấu hình cam cho băng tải
   * @param {*} params
   * @returns
   */
  async getConveyorScenarios(params) {
    const path = "conveyor-scenarios";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }
  /**
   * Lấy danh sách log băng tải
   * @param {} params
   * @returns
   */
  async getConveyorLogs(params) {
    const path = "conveyor-logs/videos";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }

  async getDvrsInStation(stationId) {
    const path = `stations/${stationId}/dvrs`;
    const configs = this.getConfigs({});
    return await this.doGet(path, configs);
  }
  async getChannelsInStation(stationId) {
    const path = `stations/${stationId}/channels`;
    const configs = this.getConfigs({});
    return await this.doGet(path, configs);
  }
  async editConveyorScenarios(data) {
    const path = `conveyor-scenarios`;
    return await this.doPost(path, data);
  }
  async deleteConveyorScenarios(id) {
    const path = `conveyor-scenarios/${id}`;
    const configs = this.getConfigs({});
    return await this.doDelete(path, configs);
  }

  async getTruckCameras(params) {
    const path = "truck-cameras";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }
  async getTruckCameraStatus(params) {
    const path = "truck-cameras/status";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }
  async getTruckCameraCaptures(params) {
    const path = "truck-cameras/capture";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }
  async getTruckCameraLogs(params) {
    const path = "truck-camera-captures";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }
  async getTruckCameraDetails(params) {
    const path = "truck-camera-captures/details";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }
  async getTruckCameraLogsExport(params) {
    const path = "truck-camera-captures/export";
    const configs = this.getConfigs({
      params,
      responseType: "blob"
    });
    return await this.doGet(path, configs);
  }
  async getTruckCameraStorage(params) {
    const path = "truck-cameras/get-storage-info";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }
  async getTruckCameraLogsDuringDay(params) {
    const path = "truck-camera-random-captures";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }

  async addErrorAssign(data) {
    const path = "truck-camera-captures/5s-error-assign";
    return await this.doPost(path, data);
  }

  async approveTruckCameraImage(data) {
    const path = "truck-camera-captures/5s-approve";
    return await this.doPost(path, data);
  }

  getTruckCameraErrors() {
    const path = "truck-camera-captures/5s-errors";
    return this.doPost(path);
  }

  uploadImageError(data) {
    const path = "truck-camera-captures/5s-image-upload";
    return this.doPost(path, data);
  }

  getTruckCameraDriver(params) {
    const path = "truck-camera-captures/latest-driver-username";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getTruckCameraCapturesV2(params) {
    const path = "truck-cameras/capture-error-image";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getTruckCameraMonitorV2Details(plate) {
    const path = `truck-cameras/capture-error-image/detail/${plate}?page=1&size=99`;
    return this.doGet(path);
  }

  getTruckCameraV2Errors() {
    const path = "truck-cameras/capture-error-image/errors";
    return this.doGet(path);
  }

  deleteTruckCameraV2Errors(id) {
    const path = `truck-cameras/capture-error-image/delete/${id}`;
    return this.doDelete(path);
  }

  // Quản lý log ảnh smartlock
  getSmartLockCameraLog(params) {
    const path = "cabinet-camera-captures";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getSmartLockCameraLogDetails(params) {
    const path = "cabinet-camera-captures/details";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }
  updateDonSuVu(data) {
    const path = "package-incidents";
    return this.doPost(path, data);
  }
  async getDvrsAttachChannels(params) {
    const path = `dvrs/attach-channels`;
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }
  async getCrossScenarios(params) {
    const path = `inbound/cross-scenarios`;
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }
  async deleteCrossScenarios(stationId) {
    const path = `inbound/cross-scenarios/${stationId}`;
    return await this.doDelete(path);
  }
  async saveCrossScenarios(data) {
    const path = `inbound/cross-scenarios`;
    return await this.doPost(path, data);
  }

  async deleteCrossbeltScenarios(id) {
    const path = `device-scenarios/${id}`;
    return await this.doDelete(path);
  }

  getCrossbeltScenarios(params) {
    const path = "device-scenarios";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  async editCrossbeltScenarios(data) {
    const path = `device-scenarios`;
    return await this.doPost(path, data);
  }

  getListCaptureConfig(params) {
    const path = "camera-capture-configs";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getDvrByStation(params) {
    const path = "dvrs/attach-channels";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  deleteCameraCaptureConfig(id) {
    const path = `camera-capture-configs/${id}`;
    return this.doDelete(path);
  }

  saveCameraCaptureConfig(data) {
    const path = `camera-capture-configs`;
    return this.doPost(path, data);
  }

  updateCameraCaptureConfig(data, id) {
    const path = `camera-capture-configs/${id}`;
    return this.doPut(path, data);
  }

  getTruckCameraStatisticReport(params) {
    const path = "/truck-cameras/capture-statistic-report";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getListStationLock(params) {
    const path = "/dvrs/station/station-lock-configs";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  addStationLock(data) {
    const path = `dvrs/station/dvr-lock-by-time`;
    return this.doPut(path, data);
  }

  addDvrLock(params, data) {
    const path = `/dvrs/lock/change`;
    return this.doPut(path, data, {
      params
    });
  }

  checkDvrPassword(params) {
    const path = "/dvrs/get-dvr-password";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getChannelByDvr(dvrId) {
    const path = `/dvrs/${dvrId}/channels`;
    return this.doGet(path);
  }

  getCameraTruck(data) {
    const path = "truck-cameras/searches";
    return this.doPost(path, data);
  }

  getImagesFullChute(params) {
    const path = "capture-requests";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  retryImagesFullChute(params) {
    const path = "capture-requests/retry";
    const configs = this.getConfigs({
      params
    });
    return this.doPut(path, "", configs);
  }

  getUserCameraPermission(params) {
    const path = "/user-permissions/stations";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  unlockCameraUser(data) {
    const path = "user-permissions/unlocks";
    return this.doPost(path, data);
  }

  addChannelCameraConfig(channelId, data) {
    const path = `channels/${channelId}/locking`;
    return this.doPut(path, data);
  }

  getInspectionScenarios(params) {
    const path = "inspection-scenarios";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  // tạo mới khu vực + cấu hình mới
  createInspectionScenario(data) {
    const path = `inspection-scenarios`;
    return this.doPost(path, data);
  }

  // Xoá cấu hình trong khu vực
  deleteInspectionScenario(id) {
    const path = `inspection-scenarios/${id}`;
    return this.doDelete(path);
  }
  // cập nhật cấu hình
  editInspectionScenario(data, id) {
    const path = `inspection-scenarios/${id}`;
    return this.doPut(path, data);
  }

  // cập nhật thông tin khu vưc
  editInspectionBlock(data, id) {
    const path = `block/inspection-scenarios/${id}`;
    return this.doPut(path, data);
  }

  // Xoá thông tin khu vực
  deleteInspectionBlock(id) {
    const path = `block/inspection-scenarios/${id}`;
    return this.doDelete(path);
  }

  uploadImageScenario(data) {
    const path = `inspection-scenarios/image-drawn`;
    return this.doPost(path, data);
  }

  getOperationalInspections(params) {
    const path = "operational-inspections";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  exportOperationalInspections(params) {
    const path = "operational-inspections/export";
    const configs = this.getConfigs({ params, responseType: "blob" });
    return this.doGet(path, configs);
  }

  retryOperationalInspections(params) {
    const path = `/operational-inspections/retry?date=${
      params.date
    }&report_time=${params.report_time}&station_id=${params.station_id}`;
    return this.doPut(path);
  }

  getCaptureInspections(params) {
    const path = "inspection-scenarios/auto-capture";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getStationAreaTags(params) {
    const path = "/station-area-tags";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  createStationAreaTag(data) {
    const path = "/station-area-tags";
    return this.doPost(path, data);
  }

  updateStationAreaTag(data, id) {
    const path = `/station-area-tags/${id}`;
    return this.doPut(path, data);
  }

  deleteStationAreaTag(id) {
    const path = `/station-area-tags/${id}`;
    return this.doDelete(path);
  }

  getChannelAreaTags(station_id, params) {
    const path = `/stations/${station_id}/channel-area-tags`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  updateChannelAreaTag(data, id) {
    const path = `/channels/${id}/area-tags`;
    return this.doPut(path, data);
  }

  exportChannelAreaTags(station_id, params) {
    const path = `/stations/${station_id}/channel-area-tags/export`;
    const configs = this.getConfigs({
      params,
      responseType: "blob"
    });
    return this.doGet(path, configs);
  }

  getUserTagsPermissions(params) {
    const path = "user-permissions/station-area-tags";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  updateUserTagsPermissions(data) {
    const path = `/user-permissions/station-area-tags`;
    return this.doPost(path, data);
  }

  createCameraTruckGifLog(data) {
    const path = `truck-camera-effect-logs`;
    return this.doPost(path, data);
  }

  updatePublicIp(data) {
    const path = `stations/dvr-public-ip`;
    return this.doPut(path, data);
  }
}
